'use client';

import { c as _c } from "react/compiler-runtime";
import React, { use, useMemo } from 'react';
import PropTypes from 'prop-types';
import PostHogFeatureFlagsContext from 'hooks/usePostHogFeatureFlag/PostHogFeatureFlagsContext';
const PDPLayoutRevampSeedBoundary = t0 => {
  const $ = _c(7);
  const {
    contextPromise,
    children
  } = t0;
  const context = contextPromise ? use(contextPromise) : null;
  let t1;
  if ($[0] !== context) {
    t1 = context ? {
      featureFlags: context.seededFeatureFlags,
      distinctId: context.evaluationDistinctId
    } : null;
    $[0] = context;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const contextValue = t1;
  if (!context) {
    return children;
  }
  let t2;
  if ($[2] !== children || $[3] !== contextValue) {
    let t3;
    if ($[5] !== contextValue) {
      t3 = {
        value: contextValue
      };
      $[5] = contextValue;
      $[6] = t3;
    } else {
      t3 = $[6];
    }
    t2 = React.createElement(PostHogFeatureFlagsContext.Provider, t3, children);
    $[2] = children;
    $[3] = contextValue;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
};
PDPLayoutRevampSeedBoundary.propTypes = {
  contextPromise: PropTypes.object,
  children: PropTypes.node
};
export default PDPLayoutRevampSeedBoundary;